import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../shared/services/common.service';
import {
  V2DailyTripPerformancePercentageValueFromReportDateToReportDateGet200Response as DailyTripPerformanceByDateRange,
  V2DailyMileageValueFromReportDateToReportDateGet200Response as MileageByDateRange,
} from '../../shared/services/openapi/reports-visual';
import { ApexAxisChartSeries, ApexNonAxisChartSeries } from 'ng-apexcharts';
import moment from 'moment';

export interface SelectType {
  label: string;
  value: string;
}

export interface ChartCategory {
  name: string;
  values: ApexAxisChartSeries | ApexNonAxisChartSeries;
}

@Injectable({
  providedIn: 'root',
})
export class ReportDashboardsApiService {
  constructor(private commonService: CommonService) {}

  defaultPeriod = 'latest';

  periodRange: SelectType[] = [
    {
      label: 'Last 7 days',
      value: 'latest',
    },
    {
      label: 'Selected Dates',
      value: 'date',
    },
    // {
    //   label: 'Monthly',
    //   value: 'monthly',
    // },
  ];

  routeIds = [];
  tripAttendance: ChartCategory[] = [];
  tripPerformance: ChartCategory[] = [];
  totalActual = 0;
  totalPlan = 0;
  selectedTripPerformance: ChartCategory = { name: 'total', values: undefined };
  selectedTripAttendance: ChartCategory = { name: 'total', values: undefined };
  getTripPerformanceByRange(fromDate: string, toDate: string) {
    const tripPerformanceRangeUrl =
      environment.apiUrl.transit +
      `/v2/dailyTripPerformancePercentageValue/${fromDate}/${toDate}`;

    this.commonService
      .commonGetFullUrlAction(tripPerformanceRangeUrl)
      .subscribe({
        next: (response: DailyTripPerformanceByDateRange) => {
          const { tripDate, tripPerformance2 } = response;

          let tripAttendanceActualTotal = 0;
          let tripAttendanceAbsentTotal = 0;
          let tripAttendancePlanTotal = 0;

          const tripPerformanceTemplate = tripDate.map(tripDateValue => ({
            x: tripDateValue,
            y: 0,
          }));

          let tripPerformanceTotal = [
            {
              name: 'On-time',
              color: '#50C878',
              data: tripPerformanceTemplate.map(object => ({ ...object })),
            },
            {
              name: 'Early',
              color: '#FFD700',
              data: tripPerformanceTemplate.map(object => ({ ...object })),
            },
            {
              name: 'Late',
              color: '#df5E42',
              data: tripPerformanceTemplate.map(object => ({ ...object })),
            },
            {
              name: 'Missing',
              color: '#98AFC7',
              data: tripPerformanceTemplate.map(object => ({ ...object })),
            },
          ];

          // summarize data
          let uniqueRoutes = new Set();
          let tripRouteAttendances: ChartCategory[] = [];
          tripPerformance2.forEach(routePerformance => {
            const { routeId, routeDetails } = routePerformance;
            uniqueRoutes.add(routeId);

            const routeTripAttendance: ChartCategory = {
              name: routeId,
              values: [0, 0],
            };

            // const routeTripPerformance: ChartCategory = {
            //   name: routeId,
            //   values: [
            //     {
            //       name: 'On-time',
            //       color: '#50C878',
            //       data: tripPerformanceTemplate.map(object => ({ ...object })),
            //     },
            //     {
            //       name: 'Early',
            //       color: '#FFD700',
            //       data: tripPerformanceTemplate.map(object => ({ ...object })),
            //     },
            //     {
            //       name: 'Late',
            //       color: '#df5E42',
            //       data: tripPerformanceTemplate.map(object => ({ ...object })),
            //     },
            //     {
            //       name: 'Missing',
            //       color: '#98AFC7',
            //       data: tripPerformanceTemplate.map(object => ({ ...object })),
            //     },
            //   ],
            // };

            routeDetails.forEach(routeData => {
              const { data } = routeData;

              data.forEach(routeValue => {
                const { name, values } = routeValue;

                if (name === 'actual') {
                  const sum = values.reduce((prev, curr) => prev + curr, 0);
                  routeTripAttendance.values[0] = sum;
                  tripAttendanceActualTotal += sum;
                }

                if (name === 'plan') {
                  const sum = values.reduce((prev, curr) => prev + curr, 0);
                  tripAttendancePlanTotal += sum;
                }

                if (name === 'absent') {
                  const sum = values.reduce((prev, curr) => prev + curr, 0);
                  routeTripAttendance.values[1] = sum;
                  tripAttendanceAbsentTotal += sum;
                }

                if (name === 'onTime') {
                  const totalOnTime = tripPerformanceTotal.find(
                    totalObj => totalObj.name === 'On-time'
                  );
                  values.forEach((curr, index) => {
                    totalOnTime.data[index].y += curr;
                  });
                }

                if (name === 'late') {
                  const totalOnTime = tripPerformanceTotal.find(
                    totalObj => totalObj.name === 'Late'
                  );
                  values.forEach((curr, index) => {
                    totalOnTime.data[index].y += curr;
                  });
                }

                if (name === 'missing') {
                  const totalOnTime = tripPerformanceTotal.find(
                    totalObj => totalObj.name === 'Missing'
                  );
                  values.forEach((curr, index) => {
                    totalOnTime.data[index].y += curr;
                  });
                }

                if (name === 'early') {
                  const totalOnTime = tripPerformanceTotal.find(
                    totalObj => totalObj.name === 'Early'
                  );
                  values.forEach((curr, index) => {
                    totalOnTime.data[index].y += curr;
                  });
                }
              });
            });

            tripRouteAttendances.push(routeTripAttendance);
          });

          this.routeIds = [...uniqueRoutes];

          const totalTripAttendance: ChartCategory = {
            name: 'total',
            values: [tripAttendanceActualTotal, tripAttendanceAbsentTotal],
          };
          const totalTripPerformance: ChartCategory = {
            name: 'total',
            values: tripPerformanceTotal,
          };

          this.tripAttendance = [totalTripAttendance, ...tripRouteAttendances];
          this.tripPerformance = [totalTripPerformance];
          // this.selectedTripAttendance = totalTripAttendance;
          this.selectedTripPerformance = totalTripPerformance;
          // this.totalActual = tripAttendanceActualTotal;
          // this.totalPlan = tripAttendancePlanTotal;

          console.log('Trip:', this.tripAttendance, this.tripPerformance);
        },
      });
  }

  tripMileage: ChartCategory[] = [];
  mileageSchedule: ChartCategory[] = [];
  selectedTripMileage: ChartCategory = { name: 'total', values: undefined };
  selectedMileageSchedule: ChartCategory = { name: 'total', values: undefined };

  totalActualMileage = 0;
  totalPlanMileage = 0;

  getMileageByRange(fromDate: string, toDate: string) {
    const mileageUrl =
      environment.apiUrl.transit +
      `/v2/dailyMileageValue/${fromDate}/${toDate}`;
    this.commonService.commonGetFullUrlAction(mileageUrl).subscribe({
      next: (response: MileageByDateRange) => {
        const { tripDate, mileage } = response;
        let mileageActualTotal = 0;
        let mileagePlanTotal = 0;
        let mileageMissingTotal = 0;

        let tripAttendanceActualTotal = 0;
        let tripAttendanceAbsentTotal = 0;
        let tripAttendancePlanTotal = 0;

        let tripMileages: ChartCategory[] = [];

        const mileageTemplate = tripDate.map(tripDateValue => ({
          x: tripDateValue,
          y: 0,
        }));

        let mileageScheduleValues = [
          {
            name: 'Actual',
            color: '#90D5FF',
            data: mileageTemplate.map(object => ({ ...object })),
          },
          {
            name: 'Missing',
            color: '#98AFC7',
            data: mileageTemplate.map(object => ({ ...object })),
          },
        ];

        mileage.forEach(routeMileage => {
          const { routeId, routeDetails } = routeMileage;

          routeDetails.forEach(routeData => {
            const { data } = routeData;
            data.forEach(routeValue => {
              const { name, values } = routeValue;

              if (name === 'actualMileage') {
                const sum = values.reduce((prev, curr) => prev + curr, 0);
                mileageActualTotal += sum;
                const totalActual = mileageScheduleValues.find(
                  totalObj => totalObj.name === 'Actual'
                );
                values.forEach((curr, index) => {
                  totalActual.data[index].y += curr / 1000;
                });
              }

              if (name === 'planMileage') {
                const sum = values.reduce((prev, curr) => prev + curr, 0);
                mileagePlanTotal += sum;
              }

              if (name === 'missingMileage') {
                const sum = values.reduce((prev, curr) => prev + curr, 0);
                mileageMissingTotal += sum;
                const totalMissing = mileageScheduleValues.find(
                  totalObj => totalObj.name === 'Missing'
                );
                values.forEach((curr, index) => {
                  totalMissing.data[index].y += curr / 1000;
                });
              }

              if (name === 'actualTrip') {
                const sum = values.reduce((prev, curr) => prev + curr, 0);
                tripAttendanceActualTotal += sum;
              }

              if (name === 'planTrip') {
                const sum = values.reduce((prev, curr) => prev + curr, 0);
                tripAttendancePlanTotal += sum;
              }

              if (name === 'missingTrip') {
                const sum = values.reduce((prev, curr) => prev + curr, 0);
                tripAttendanceAbsentTotal += sum;
              }
            });
          });
        });

        const totalTripAttendance: ChartCategory = {
          name: 'total',
          values: [tripAttendanceActualTotal, tripAttendanceAbsentTotal],
        };

        this.selectedTripAttendance = totalTripAttendance;
        this.totalActual = tripAttendanceActualTotal;
        this.totalPlan = tripAttendancePlanTotal;

        const totalMileage: ChartCategory = {
          name: 'total',
          values: [mileageActualTotal / 1000, mileageMissingTotal / 1000],
        };
        this.tripMileage = [totalMileage];
        this.selectedTripMileage = totalMileage;

        const totalMileageSchedule: ChartCategory = {
          name: 'total',
          values: mileageScheduleValues,
        };
        this.mileageSchedule = [totalMileageSchedule];
        this.selectedMileageSchedule = totalMileageSchedule;
        this.totalActualMileage =
          Math.round((mileageActualTotal / 1000) * 100) / 100;
        this.totalPlanMileage =
          Math.round((mileagePlanTotal / 1000) * 100) / 100;

        console.log('Trip:', this.tripMileage, this.mileageSchedule);
      },
    });
  }

  currentDate: string;
  pastWeekDate: string;
  initDashboard() {
    // past 7 days
    this.currentDate = moment().format('YYYY-MM-DD');
    this.pastWeekDate = moment().subtract(7, 'day').format('YYYY-MM-DD');

    this.getTripPerformanceByRange(this.pastWeekDate, this.currentDate);
    this.getMileageByRange(this.pastWeekDate, this.currentDate);
  }

  clearDashboard() {}

  getLatestValues() {
    this.getTripPerformanceByRange(this.pastWeekDate, this.currentDate);
    this.getMileageByRange(this.pastWeekDate, this.currentDate);
  }

  getValuesFromDate(startDate: string, endDate: string) {
    this.getTripPerformanceByRange(startDate, endDate);
    this.getMileageByRange(startDate, endDate);
  }
}
